import { defineLocale } from "../../registry";

const catalog = defineLocale({
  ru: {
    "catalog.table.label": "Picks",
    "catalog.new": "Новый Pick",
    "catalog.col.cover": "Обложка",
    "catalog.col.title": "Название",
    "catalog.col.category": "Категория",
    "catalog.col.place": "Место",
    "catalog.col.status": "Статус",
    "catalog.col.visibility": "Видимость",
    "catalog.col.price": "Цена",
    "catalog.col.updated": "Обновлено",
    "catalog.col.deal": "Статус сделки",
    "catalog.cover.unavailable": "Нет обложки",
    "catalog.noValue": "—",
    "catalog.deal.signed": "Подписано",
    "catalog.deal.editorial_only": "Только редакционный",
    "catalog.deal.pending": "В ожидании",
    "catalog.deal.declined": "Отклонено",
    "catalog.deal.unknown": "Неизвестный статус сделки",
    "catalog.price.unit.person": "за человека",
    "catalog.price.unit.night": "за ночь",
    "catalog.price.unit.group": "за группу",
    "catalog.price.unit.package": "за пакет",
  },
  en: {
    "catalog.table.label": "Picks",
    "catalog.new": "New pick",
    "catalog.col.cover": "Cover",
    "catalog.col.title": "Title",
    "catalog.col.category": "Category",
    "catalog.col.place": "Place",
    "catalog.col.status": "Status",
    "catalog.col.visibility": "Visibility",
    "catalog.col.price": "Price",
    "catalog.col.updated": "Updated",
    "catalog.col.deal": "Deal status",
    "catalog.cover.unavailable": "No cover",
    "catalog.noValue": "—",
    "catalog.deal.signed": "Signed",
    "catalog.deal.editorial_only": "Editorial only",
    "catalog.deal.pending": "Pending",
    "catalog.deal.declined": "Declined",
    "catalog.deal.unknown": "Unknown deal status",
    "catalog.price.unit.person": "per person",
    "catalog.price.unit.night": "per night",
    "catalog.price.unit.group": "per group",
    "catalog.price.unit.package": "per package",
  },
});

export default catalog;
